exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".root[data-v-2f91bd12]{width:33%;display:flex;flex-direction:column;align-items:center}.brick[data-v-2f91bd12]{width:4rem;height:4rem}\n", ""]);

